module.exports = __webpack_public_path__ + "img/pirl.8382aa84.svg";